function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        var value = r[2];
        value = value.replace(/(%22|%3E|%3C|<|>)/g, "MM");
        return decodeURIComponent(value);
    } else {
        return null;
    }
}
function isIOS() {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
function encryptionString() {
    var str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    return str.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}
function objToString(obj) {
    var b = [];
    for (let i in obj) {
        if (obj[i]) b.push([i, obj[i]]);
    }
    return b;
}
function dateConverter(formatData, timestamp) {
    Date.prototype.format = function(format) {
        var o = {
            "M+": this.getMonth() + 1, //month
            "d+": this.getDate(), //day
            "h+": this.getHours(), //hour
            "m+": this.getMinutes(), //minute
            "s+": this.getSeconds(), //second
            "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
            "S": this.getMilliseconds() //millisecond
        };
        
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    };
    var timeFormat = new Date(timestamp);
    return timeFormat.format(formatData);
}

import sdk from "../sdk/sdk";
import util from "../util/index";
import newApi from "../../fetch/newApi";
import axios from 'axios'
var burialPoint = {
    from: getQueryString('dt_from') || 'app',//app/web
    from_user_id: getQueryString('from_user_id') || '',//记录页面从站内分享到站外时，分享者的id，该字段在站外页面跳转时一直保留
    serial_num: getQueryString('serial_num') || '',//记录页面从站内分享到站外时，分享者的编码，该字段在站外页面跳转时一直保留
    from_guid: getQueryString('from_guid') || '',//记录页面从站内分享到站外时，分享者的设备ID，该字段在站外页面跳转时一直保留
    from_sign_id: getQueryString('from_sign_id') || '',//纯站外页面区分来源用参数，参数由运营人员添加，如果有此参数，则页面跳转时需要带上
    target_id: getQueryString('target_id') || '',
    url: location.href,
    from_id: getQueryString('from_id') || '',//记录页面从站内分享到站外时，分享者的当时点击分享按钮的事件ID，该字段在站外页面跳转时一直保留
    hash_id: null,//浏览器指纹，标记唯一值
    //from_object:$.getQueryString('from_object'),//上层页面埋点事件ID，app跳转h5时会带上的字段
    pageid: null,//页面唯一ID
    frameid: null,//所有埋点页面都会有框架ID （某个版本v1.0.0做了三个埋点页面，则三个页面的frameid均为v1.0.0,同理）
    // from_frameid:$.getQueryString('from_frameid'),//上层页面ID，页面跳转时会带上的字段，该值为空代表没有上级页面
    // from_resourceid:$.getQueryString('from_resourceid'),//上层页面埋点事件ID，h5跳转h5/app时会带上的字段
    opentime: getQueryString('opentime'),//页面首次打开时间，初始化时填入
    hideShowPoint: getQueryString('hideShowPoint') || 0,//是否需要页面展示埋点
    initParams: null,//页面展示事件埋点所带额外参数
    /**
     * @method 初始化埋点框架,页面初始化时需要手动调用下
     * @param {String} pageid 页面ID
     * @param {String} frameid 框架ID
     * @param {Boolean} initParams 埋点额外参数
     * @param {Boolean} hideShow 是否隐藏页面展示埋点
     * */
    init: function (pageid, frameid, initParams, hideShow) {
        if (!pageid) return//页面id不传则不执行初始化
        this.pageid = pageid;//赋值当前页面ID
        this.frameid = frameid;//赋值当前页面frameid
        this.initParams = initParams;
        this.addEventListeners();//监听页面处理事件
        this.opentime = Math.floor(new Date().getTime() / 1000);//页面打开时间-单位秒
        this.hideShowPoint = this.hideShowPoint || hideShow
        if (!this.hideShowPoint)this.addEvent(this.pageid, null, null, 0);//首次进入页面时，调用下页面展示的埋点
    },
    //事件监听处理
    addEventListeners: function () {
        var that = this;
        /*window.addEventListener("popstate", function () {//监听到浏览器回退事件，重新执行页面展开事件
            that.init(that.pageid, that.frameid, that.initParams);//监听页面回退，重新渲染
        }, false);*/
    },
    /**
     * @method 增加埋点 根据当前页面所在环境，调用app/web埋点
     * @param {String} eventId 埋点事件ID
     * @param {Object} extraParams 自定义参数
     * @param {String} jumpUrl 要跳转的地址
     * @param {Number} type 0=页面展示事件/1=点击事件-产生跳转/2=滑动事件/3=点击事件-不跳转
     * @param {Function} func 回调方法
     * @param {Number} burialPointType 2=beacon协议方式触发埋点
     */
    addEvent: function (eventId, extraParams, jumpUrl, type, func,burialPointType) {//添加埋点
        let that = this;
        var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
        var application = 'web';
        if (!eventId || !this.pageid) return//当前事件id为空或者页面id为空，则不做任何处理
        if (type == null || type == undefined) type = 3;//默认设为点击事件
        var params = {
            opentime: this.opentime
        }
        params = Object.assign(params,this.initParams);//init的额外参数拼接到所有埋点中
        params = Object.assign(params,extraParams);//拼接上当前埋点需要的额外参数
        var u = navigator.userAgent;
        
        if (this.from == 'app') {
            util.getVersion().then(function (value) {
                let version = util.judgeVersionEnough('2.10.0', value);
                if(burialPointType == 2 && isIOS() && version) {
                    location.href = "beacon://webMobClick?eventId="+eventId+"&frameid="+that.frameid
                        +"&action_type="+type+"&buryParam="+JSON.stringify(params);
                }else if(burialPointType == 2 && isIOS()) {
                    return;
                }else {
                    sdk.beacon.webMobClick({//调用app埋点
                        eventId: eventId,//事件ID
                        frameid: that.frameid,//页面ID
                        action_type: type,//事件类型
                        buryParam: params
                    }, function (data) {
                    });
                }
                if (!jumpUrl) return;//埋点后无需跳转地址，直接返回
                location.href = jumpUrl
            });
        } else if (this.from != 'app' ) {
            var time = new Date().getTime(), platform = 'android', params2, data, options, i, source;
            if(isMobile){ //区分手机端 电脑参数
                if (isIOS()) {
                    platform = 'ios';
                }
            }else {
                application = 'browser';
                if(/windows|win32/i.test(navigator.userAgent)){
                    platform = 'windows';
                }else{
                    platform = 'Mac';
                }
            }
            params2 = {//此处参数为跳转链接时需要带到下一个页面的参数
                from_user_id: that.from_user_id,    // 站内来源用户id     来源上层url 上层url带来的user_id，无为空
                serial_num: that.serial_num,    	// 站内来源用户编码     来源上层url 上层url带来的user_id，无为空
                from_guid: that.from_guid,          // 站内来源用户guid   来源上层url 上层url带来的guid，无为空
                from_id: that.from_id,              // 站内来源埋点       来源上层url 上层url带来的id，无为空
                from_sign_id: that.from_sign_id,    // 来源标识          扩充字段，方案未标记为空。
                target_id: that.target_id           // 对象id
            };
            params = Object.assign(params,params2);//拼接上当前埋点需要的额外参数
            var sendParams = Object.assign({
                hash_id: encryptionString(),
                id: type == 0 ? eventId : (that.pageid + '.' + eventId),        // 埋点事件id拼装格式为 pageid+'.'+eventid ,页面展示事件则id=pageid
                createtime: Math.floor(time / 1000),                   // 操作时间
                application: application,                 // 应用
                platform: platform,                 // 来源
                url: that.url,                      // 当前地址          记录来源页面id，无为空。
            },params); //sendParams表示埋点统一发送接口需要传的值
    
            var paramsToLine = objToString(params2).join("|").replace(/,/g, '=');//跳转下个页面需要带上的参数
            var sendParamsToLine = objToString(sendParams).join("|").replace(/,/g, '=');//需要发送埋点的参数
            if (!extraParams || !extraParams.source) {
                source = 5
            } else {
                source = extraParams.source;
            }
            var data = {
                line: sendParamsToLine,
                sendTime: dateConverter('yyyy-MM-dd hh:mm:ss', time),//传值格式YYYY-MM-DD hh:mm:ss
                source: source,//1=ios 2=android 5=手机web
            }
            axios.post(newApi.getAjaxUrl('dtlog','burialPoint'),data).then(res=>{
                func ? func() : that.skipUrl(paramsToLine, jumpUrl)
            }).catch(error => {
                func ? func() : that.skipUrl(paramsToLine, jumpUrl)
            })
        }
    },
    skipUrl: function (result, jumpUrl) {
        if (!jumpUrl) return;//埋点后无需跳转地址，直接返回
        var data2 = result.replace(/\|/g, '&');
        if (data2) {
            if (jumpUrl.indexOf('?') !== -1) {
                jumpUrl = jumpUrl + '&' + data2;
            } else {
                jumpUrl = jumpUrl + '?' + data2;
            }
        }
        location.href = jumpUrl
    }
}
export default burialPoint



// WEBPACK FOOTER //
// ./src/plugins/burialPoint/index.js